import { Box, Typography } from "@mui/material";
import { alpha } from "@mui/material/styles";
import Image from "next/image";
import React from "react";
import Coin from "../../../assets/stcoin.png";
import { CART_MINT_DARK } from "./cartUi";
import "./index.css";

interface FreeCoinsProps {
  cart: any;
}

export const FreeCoins: React.FC<FreeCoinsProps> = ({ cart }) => {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: 1,
        padding: "10px 14px",
        border: `1px solid ${alpha("#d97706", 0.35)}`,
        borderRadius: "14px",
        background: `linear-gradient(135deg, ${alpha("#fffbeb", 0.95)} 0%, ${alpha("#fef3c7", 0.35)} 100%)`,
        marginTop: { xs: 0, sm: "1.25rem" },
        boxShadow: `0 4px 16px ${alpha(CART_MINT_DARK, 0.05)}`,
      }}
    >
      <Image
        className="cart-coin-animation"
        src={Coin}
        height={500}
        width={500}
        alt="coin"
        style={{
          height: "2rem",
          width: "2rem",
          flexShrink: 0,
        }}
      />
      <Typography
        variant="body2"
        sx={{
          textAlign: "left",
          color: CART_MINT_DARK,
          fontWeight: 700,
          fontSize: { xs: "0.8rem", sm: "0.875rem" },
          lineHeight: 1.4,
        }}
      >
        You will get{" "}
        {cart?.cashbackSalontymCoins ? cart?.cashbackSalontymCoins : 0}{" "}
        Salontym Coins when the service is completed.
      </Typography>
    </Box>
  );
};
